import './date-range-filter.scss';

import { func, string } from 'prop-types';
import React, { Component } from 'react';
import {
  Button,
  ButtonDropdown,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';

import DateRange from '../DateRange';
import InfoTooltip from '../Tooltip/InfoTooltip';

const dateRangeTooltip =
  'Setting a Start and End Date range filter will provide you a list of values that fall within the specified range for this field.';

class DateRangeFilter extends Component {
  state = {
    startDate: null,
    endDate: null,
    dropdownOpen: false,
  };

  onChange = ({ target: { value, name } }) => {
    this.setState({ [name]: value });
  };

  toggle = () => {
    this.setState(state => ({
      dropdownOpen: !state.dropdownOpen,
    }));
  };

  filter = () => {
    const { startDate, endDate } = this.state;
    if (startDate && endDate) {
      this.props.onChange({
        startDate,
        endDate,
      });
      this.setState({
        dropdownOpen: false,
      });
    }
  };

  reset = () => {
    this.setState({ startDate: null, endDate: null });
    this.props.onChange({ startDate: null, endDate: null });
  };

  render() {
    const { startDate, endDate } = this.state;
    return (
      <ButtonDropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
        <DropdownToggle color="light" caret>
          Filter
          <InfoTooltip target="date-range-tooltip">
            {dateRangeTooltip}
          </InfoTooltip>
        </DropdownToggle>
        <DropdownMenu>
          <div className="d-flex p-2">
            <DateRange
              id={this.props.id}
              startName="startDate"
              endName="endDate"
              startDate={startDate}
              endDate={endDate}
              small
              onChange={this.onChange}
            />
            <Button
              className="btn btn-secondary ml-2 date-filter-apply"
              onClick={this.filter}
            >
              Apply
            </Button>
            <Button
              className="btn btn-secondary ml-2 date-filter-reset"
              onClick={this.reset}
            >
              Clear
            </Button>
          </div>
        </DropdownMenu>
      </ButtonDropdown>
    );
  }
}

DateRangeFilter.propTypes = {
  id: string.isRequired,
  onChange: func.isRequired,
};

export default DateRangeFilter;
